import React from "react";
import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { cardCls, labelCls } from "./tokens";

/**
 * StatCard — KPI tile with icon, value, label, and trend.
 * Variants: trend = "up" | "down" | "neutral"
 */
export default function StatCard({
  label,
  value,
  trend,
  trendValue,
  Icon,
  helper,
  testId,
}) {
  const trendColor =
    trend === "up"
      ? "text-onedesk-success"
      : trend === "down"
      ? "text-onedesk-danger"
      : "text-onedesk-textSecondary";
  const TrendIcon =
    trend === "up" ? ArrowUpRight : trend === "down" ? ArrowDownRight : Minus;

  return (
    <div
      className={`${cardCls} p-6 flex flex-col gap-3`}
      data-testid={testId || `stat-card-${(label || "").toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-start justify-between gap-3">
        <span className={labelCls}>{label}</span>
        {Icon ? (
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-od-input bg-onedesk-bg">
            <Icon className="h-4 w-4 text-onedesk-primary" strokeWidth={2.25} />
          </span>
        ) : null}
      </div>
      <div className="font-bold text-3xl text-onedesk-textPrimary tracking-tight">
        {value}
      </div>
      {(trend || helper) && (
        <div className="flex items-center gap-2 text-xs">
          {trend && (
            <span className={`inline-flex items-center gap-1 font-bold ${trendColor}`}>
              <TrendIcon className="h-3.5 w-3.5" strokeWidth={2.5} />
              {trendValue}
            </span>
          )}
          {helper && (
            <span className="font-medium text-onedesk-textSecondary">{helper}</span>
          )}
        </div>
      )}
    </div>
  );
}
